module.exports = __webpack_public_path__ + "img/page02_image3.b4d5015f.svg";